<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    新安站<br>
站点介绍<br>
新安站位于宝安区新湖路与新安一路交叉口和新圳河下方，顺新湖路布置，车站大致呈东南至西北走向。作为深圳历史文化的发源地，“新安故城”有着重要的历史价值及人文特质，故车站整体装修以蓝色为主，表现了新安区域厚重的历史感。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:32	23:19	1号线	2分钟	4分40秒<br>
机场东	06:01	23:49	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:39	23:19	1号线	3分45秒	5分45秒<br>
机场东	06:07	23:47	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:39	00:19	1号线	3分45秒	5分45秒<br>
机场东	06:07	00:47	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br>
A出入口:<br>
新湖路北侧（东）、新安一路东侧、宝安实验学校、凯旋城、新城联检站<br><br>
B出入口:<br>
新安一路西侧、新湖路北侧（西）、中商花园、中南花园、新锦安雅园<br><br>
C出入口:<br>
甲岸路（北）、西岸观邸、西岸茶城<br><br>
D出入口:<br>
新湖路南侧（西）、甲岸路（南）、熙龙湾一期<br><br>
E出入口:<br>
宝安区中心血站、南方医科大学深圳医院、深圳宝安区疾病预防控制中心、熙龙湾二期、新湖路南侧（东）<br><br>
公交换乘信息<br>
A出入口:<br>
公交站名： 凯旋城<br>
718、M550、M246、M235、M473<br><br>
A出入口:<br>
公交站名： 南医大深圳医院<br>
M131、M473、M157、M246<br><br>
B出入口:<br>
公交站名： 新安地铁站<br>
718、M550、M235、M157<br><br>
B出入口:<br>
公交站名： 凯旋城<br>
718、M550、M235<br><br>
D出入口:<br>
公交站名： 新安地铁站<br>
718、M550、M235、M157<br><br>
E出入口:<br>
公交站名： 南医大深圳医院<br>
M157<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>





